export default __webpack_public_path__ + "locales/vi/JavascriptSdk.json?hash=dc9737205ec168b6d26f6669aeee7ab7";